import React from 'react';
import logoImage from '../../../public/static/images/rat-race/logo.png';
import ratLogo from '../../../public/static/images/rat-race/rat-logo.png';
import appStoreImage from '../../../public/static/images/rat-race/app-store.png';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;

export default function RatRaceNav() {
  return (
    <header className={styles.navbar}>
      <div className={styles.navInner}>
        <div className={styles.brandWrap}>
          <img
            className={styles.brandLogo}
            src={getAssetSrc(logoImage)}
            alt="Rat Race logo"
          />
          <img
            className={styles.brandImage}
            src={getAssetSrc(ratLogo)}
            alt="Rat Race mascot"
          />
        </div>
        <button
          type="button"
          className={`${styles.downloadButton} ${styles.desktopOnly}`}
        >
          Download The App
        </button>
        <a href="#" className={styles.appStoreButton}>
          <img
            src={getAssetSrc(appStoreImage)}
            alt="Download on the App Store"
            className={styles.appStoreImage}
          />
        </a>
      </div>
    </header>
  );
}
